import _ from 'lodash';
import * as sites from 'goodeggs-sites';
import NamedError from 'goodeggs-named-error';

export default __filename;
angular.module(__filename, []).factory(
  'Supplier',
  ngInject(function($http, settings) {
    return {
      getSuppliers: _.memoize((goodeggsLocationId) =>
        $http({
          method: 'POST',
          url: `${sites.getUrl('catalog-api', settings)}/graph`,
          data: {
            operationName: 'getSuppliers',
            variables: {goodeggsLocationId},
            query: `\
query getSuppliers($goodeggsLocationId: String) {
  suppliers (goodeggsLocationId: $goodeggsLocationId, hideDeleted: true) {
    id
    name
    slug
    goodeggsLocationIds
    email
    isDeleted
  }
}\
`,
          },
        }).then((result) => {
          const graphQLResponse = result.data;

          if (graphQLResponse.errors != null) {
            throw new NamedError({
              message: 'Error response from Catalog API for getSuppliers query',
              data: {result},
            });
          }
          if (graphQLResponse.data == null || graphQLResponse.data.suppliers == null) {
            throw new NamedError({
              message: 'Unexpected response from Catalog API for getSuppliers query',
              data: {result},
            });
          }
          return graphQLResponse.data.suppliers;
        }),
      ),
      getBySlug(slug) {
        return this.getSuppliers().then((suppliers) =>
          suppliers.find((supplier) => supplier.slug === slug),
        );
      },
      getById(id) {
        return this.getSuppliers().then((suppliers) =>
          suppliers.find((supplier) => supplier.id === id),
        );
      },
    };
  }),
);
